import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { Accordion, Nav, Col, useAccordionButton } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuthentication, useApp, useTheme } from '../../Hooks';
import { SvgComponent } from '../SvgComponent/SvgComponent';
import { AnimatedIconButton } from '../AnimatedIconButton/AnimatedIconButton';
import './SideBar.style.css'

export const SideBar = () => {
  const [userCollapseState, setUserCollapseState] = useState(false);
  const {usuario} = useAuthentication();
  const {configuration} = useApp();
  const {theme} = useTheme();
  const [expandedMenuIndex, setExpandedMenuIndex] = useState(null);
  const [showAllSubmenus, setShowAllSubmenus] = useState(null);
  const [showAllMenus, setShowAllMenus] = useState(false);
  const sideBarRef = useRef(null);
  const [fijado, setFijado] = useState(2);
  const navigate = useNavigate();
  const userMenuRef = useRef(null);
  function manageGoTo(url) {
    if (url.toLowerCase().includes('/pos/') || url.toLowerCase().includes('expertos')) {
      openInNewTab(url);
    } else {
      navigate(url);
    }
  }

  useEffect(() => {
    const storedFijado = localStorage.getItem('toggleType');
    if (storedFijado) {
      let fijar = JSON.parse(storedFijado);
      setFijado(fijar);
      const sidebar = document.querySelector(".sidebar");
      if(fijar === 0){
        sidebar.classList.add('extended');
      }
      else if(fijar === 2) {
        if(sidebar && sideBarRef.current && userMenuRef.current) {
          sidebar.classList.add("no-hover");
          sideBarRef.current.classList.add("no-hover");
          userMenuRef.current.classList.add("no-hover");
        }
      }
      cambiarMarginMainPanel(fijar);
    }
  }, []);
  
  useEffect(() => {
    const sidebar = document.querySelector(".sidebar");
    const handleMouseEnter = () => {
      if(fijado === 2 && !sidebar.classList.contains('extended')){
        sidebar.classList.add("no-hover");
        sideBarRef.current.classList.add("no-hover");
        userMenuRef.current.classList.add("no-hover");
      }else {
        sidebar.classList.remove("no-hover");
        sideBarRef.current.classList.remove("no-hover");
        userMenuRef.current.classList.remove("no-hover");
        sidebar.classList.add("extended");
      }
    }
    const handleDocumentClick = (event) => {
        if (fijado === 0) {

        } else if (fijado === 1) {
            if ((!sidebar.contains(event.target) || event.target.getAttribute("id") === "subMenus")) {
                setExpandedMenuIndex(null);
                setShowAllSubmenus(null);
                setShowAllMenus(false);
                setTimeout(() => {
                    sidebar.classList.remove("extended");
                }, 50);
            }
        } else if (fijado === 2) {
            if ((!sidebar.contains(event.target))) {
                setExpandedMenuIndex(null);
                setShowAllSubmenus(null);
                setShowAllMenus(false);
                setTimeout(() => {
                    sidebar.classList.remove("extended");
                }, 50);
            }
        }
    }
    sidebar.addEventListener("mouseenter",handleMouseEnter);
    document.addEventListener("click", handleDocumentClick);

    sidebar.addEventListener("click", function (event) {
      let target = event.target;
      let id = target.getAttribute("id");
      if (id === "subMenus") {
        const clickEvent = new Event("click", {
          bubbles: true,
          cancelable: true,
        });
        if(fijado !== 0 && id !== "subMenus"){
          document.dispatchEvent(clickEvent);
        }
      }
    });
    document.addEventListener("iframeOutsideClick", function () {
      const clickEvent = new Event("click", {
        bubbles: true,
        cancelable: true,
      });
      if(fijado !== 0){
        document.dispatchEvent(clickEvent);
      }
    });

    return () => {
      sidebar.removeEventListener("mouseenter", handleMouseEnter);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [fijado]);


  const openInNewTab = useCallback((url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  }, []);
  const toggleSubMenu = (index) => {
    setExpandedMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const toggleAllSubMenu = (index) => {
    setShowAllSubmenus((prevIndex) => (prevIndex === index ? null : index));
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
  }, []);
  const handleOutsideClick = (e) => {
    if (sideBarRef.current && !sideBarRef.current.contains(e.target) && fijado === 0) {
      setExpandedMenuIndex(null);
      setShowAllSubmenus(null);
      setShowAllMenus(false);
    }
  };
  const createLinks = useMemo(() => {
    if (usuario && usuario?.Menus) {
      return (
        <React.Fragment>
          {usuario?.Menus?.map((menu, index) => {
            if (
              usuario?.CompaniaId === 10 &&
              !(
                menu.Nombre.includes("Admin") ||
                menu.Nombre.includes("Cobrar") ||
                    menu.Nombre.includes("Cardnet") ||
                    menu.Nombre.includes("Caja Chica") ||
                menu.Nombre.includes("Factura")
              )
            ) {
              const usuarios = [
                30, 31, 1053, 262, 5312, 1127, 1157, 1031, 2815, 377, 3079,
              ];
              if (!usuarios.includes(usuario?.UsuarioId)) {
                return null;
              }
            }
            return (
              <React.Fragment key={`${menu.MenuId}`}>
                {(!usuario?.menuLog || showAllMenus || index < 10) && (
                  <Nav.Item
                    className={
                      index > 9 ? "specialItem nav-animation" : "specialItem"
                    }
                    key={`${menu.MenuId}`}
                    as="li"
                  >
                    <Nav.Link
                      style={{
                        display: "flex",
                        alignContent: "left",
                        alignItems: "center",
                        textDecoration: "none",
                        outline: "none",
                        width: "-webkit-fill-available",
                        height: "45px",
                      }}
                      onClick={() => toggleSubMenu(index)}
                    >
                      <div
                        style={{
                          marginLeft: "3px",
                          marginRight: "3px",
                          maxHeight: "35px",
                        }}
                      >
                        <SvgComponent
                          iconName={menu.Nombre}
                          height="35"
                          width="35"
                          fill="white"
                        />
                      </div>
                      <p
                        style={{
                          marginLeft: "15px",
                          fontSize: "15px",
                          marginRight: "15px",
                          backgroundColor: "unset",
                          textAlign: "left",
                        }}
                        className="menuName"
                      >
                        {menu.Nombre}
                      </p>
                    </Nav.Link>
                  </Nav.Item>
                )}

                {/* Submenu rendering logic */}
                {expandedMenuIndex === index && (
                  <Nav
                    as="ul"
                    className={"nav-animation"}
                    style={{ display: "block" }}
                  >
                    {menu.Submenu.map(
                      (submenu, subIndex) =>
                        (showAllSubmenus === index || subIndex < 5) && (
                          <Nav.Item
                            id="subMenus"
                            className={
                              subIndex > 3
                                ? "specialItem nav-animation"
                                : "specialItem"
                            }
                            key={submenu.Nombre}
                            as="li"
                            style={{
                              marginLeft: "15px",
                              height: "35px",
                            }}
                          >
                            <Nav.Link
                              as={Link}
                              to={submenu.URL}
                              onClick={(e) => {
                                e.preventDefault()
                                manageGoTo(submenu.URL)
                              }}
                              id="subMenus"
                              style={{
                                display: "flex",
                                alignContent: "left",
                                alignItems: "center",
                                textDecoration: "none",
                                outline: "none",
                                width: "-webkit-fill-available",
                                paddingTop: "0px",
                                paddingBottom: "0px",
                              }}
                            >
                              <div
                                style={{
                                  marginLeft: "3px",
                                  marginRight: "3px",
                                  marginBottom: "2px",
                                }}
                              >
                                <SvgComponent
                                  id="subMenus"
                                  iconName="submenu"
                                  height="24"
                                  width="24"
                                  fill="white"
                                />
                              </div>
                              <p
                                id="subMenus"
                                style={{
                                  marginLeft: "18px",
                                  fontSize: "13px",
                                  marginRight: "0px",
                                  backgroundColor: "unset",
                                  textAlign: "left",
                                  width: "auto",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                className="menuName"
                              >
                                {submenu.Nombre}
                              </p>
                            </Nav.Link>
                          </Nav.Item>
                        )
                    )}
                    {/* Toggle button for showing more submenus */}
                    {menu.Submenu.length > 5 && (
                      <Nav.Item
                        className={"specialItem"}
                        as="li"
                        style={{
                          marginLeft: "3px",
                          height: "35px",
                        }}
                        key={'subMenuToggleButton'}
                      >
                        <Nav.Link
                          onClick={() => toggleAllSubMenu(index)}
                          style={{
                            display: "flex",
                            alignContent: "left",
                            alignItems: "center",
                            textDecoration: "none",
                            outline: "none",
                            width: "-webkit-fill-available",
                            paddingTop: "0px",
                            paddingBottom: "0px",
                            backgroundColor: "white",
                            borderRadius: "4px",
                            marginRight: "3px",
                            marginLeft: "0px",
                          }}
                        >
                          <div
                            style={{
                              marginLeft: "3px",
                              marginRight: "3px",
                              marginBottom: "2px",
                            }}
                          >
                            <SvgComponent
                              iconName={
                                showAllSubmenus != index ? "plus" : "minus"
                              }
                              height="24"
                              width="24"
                              fill="#1e90ff"
                            />
                          </div>
                          <p
                            style={{
                              marginLeft: "18px",
                              fontSize: "13px",
                              marginRight: "0px",
                              backgroundColor: "unset",
                              textAlign: "left",
                              width: "auto",
                              color: "#1e90ff",
                            }}
                            className="menuName"
                          >
                            {showAllSubmenus === index
                              ? "Ver menos"
                              : "Ver más"}
                          </p>
                        </Nav.Link>
                      </Nav.Item>
                    )}
                  </Nav>
                )}
              </React.Fragment>
            );
          })}
          {/* Toggle button for showing more menus */}
          {usuario?.menuLog && usuario?.Menus?.length > 10 && (
            <Nav.Item
              className={"specialItem"}
              as="li"
              style={{
                background: "white",
                marginLeft: "3px",
                borderRadius: "4px",
                marginRight: "3px",
              }}
              key={'menuToggleButton'}
            >
              <Nav.Link
                style={{
                  display: "flex",
                  alignContent: "left",
                  alignItems: "center",
                  textDecoration: "none",
                  outline: "none",
                  width: "-webkit-fill-available",
                  height: "45px",
                }}
                onClick={() => setShowAllMenus(!showAllMenus)}
              >
                <div
                  style={{
                    marginRight: "3px",
                    maxHeight: "35px",
                  }}
                >
                  <SvgComponent
                    iconName={showAllMenus ? "minus" : "plus"}
                    height="35"
                    width="35"
                    fill="#1e90ff"
                  />
                </div>
                <p
                  style={{
                    marginLeft: "15px",
                    fontSize: "15px",
                    marginRight: "15px",
                    textAlign: "left",
                    backgroundColor: "unset",
                    color: "#1e90ff",
                  }}
                  className="menuName"
                >
                  {showAllMenus ? "Ver menos" : "Ver más"}
                </p>
              </Nav.Link>
            </Nav.Item>
          )}
        </React.Fragment>
      );
    }
    return null; // Return null if usuario or usuario.Menus is not defined
  }, [usuario, expandedMenuIndex, showAllSubmenus, showAllMenus]);
  function cambiarMarginMainPanel(fijar){
    const mainPanel = document.querySelector(".main-panel");
    if(fijar === 0){
      mainPanel.style.marginLeft = '275px' 
      mainPanel.style.width = 'calc(100% - 275px)'
    }else {
      mainPanel.style.marginLeft = '80px'
      mainPanel.style.width = 'calc(100% - 80px)'
    }
  }
  function toggleFijado(number){
    
    let toggleType = number;
    if(toggleType > 2){
        toggleType = 0;
    }
    
    setFijado(toggleType);
    localStorage.setItem('toggleType', JSON.stringify(toggleType));
    cambiarMarginMainPanel(toggleType)
    const sidebar = document.querySelector(".sidebar");
    if(!sidebar.classList.contains('extended') && toggleType !== 2){
      sidebar.classList.add('extended')
    }
  }

  const CustomToggle = ({ children, eventKey }) => {
    const decoratedOnClick = useAccordionButton(eventKey, () =>
      setUserCollapseState((prevState) => !prevState)
    );

    return (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          decoratedOnClick();
        }}
        className={`p-0 mt-2 ${userCollapseState ? "mb-1" : ""}`}
        style={{ textDecoration: "none" }}
      >
        {children}
      </a>
    );
  };
  return (
    <React.Fragment>
      {(usuario !== null && createLinks !== null) && (
        <div
          onClick={(e) => {
            if(fijado===2){
              const sidebarWrapper = document.querySelector(".sidebar-wrapper");
              const sidebar = document.querySelector(".sidebar");
              if(sidebar && sidebarWrapper) {
                sidebar.classList.remove("no-hover");
                sidebar.classList.add("extended");
                sidebarWrapper.classList.remove("no-hover");
              }
            }
          }}  
          className={`sidebar-wrapper`}
          style={{
            overflowX: "hidden",
            overflowY: "scroll",
          }}
          ref={sideBarRef}
        >
          <div
            id="subMenus"
            style={{
              backgroundColor: "#fefefe",
              width: "275px",
              zIndex: "900013",
              position: 'fixed',
              padding: "0px",
              margin: "0px",
            }}
          >
            <div
              id="subMenus"
              className="logo changingImg"
              style={{
                paddingTop: "0px",
                height: "70px",
                width: "50px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.preventDefault()
                manageGoTo("/")
              }}
            >
              <a
                id="subMenus"
                className="simple-text"
                style={{ paddingTop: "0px" }}
              >
                <div
                  id="subMenus"
                  className="logo-normal"
                  style={{ backgroundColor: "#fefefe" }}
                >
                  {
                    <img
                      id="subMenus"
                      style={{
                        objectFit: "contain",
                      }}
                      src={usuario?.Compania?.Logo || '/img/logo/default.png'}
                      height="70px"
                      width="80px"
                      className="logo-compania"
                    />
                  }
                </div>
              </a>
            </div>
          </div>
          <div
              style={{position: "absolute", right: 5, top: 72, zIndex: 900011}}
          className="pinSidebar"
          >
            <AnimatedIconButton
                iconName={fijado === 0 ? 'pin' : fijado === 1 ? 'unpin' : "click"}
                height="18"
                width="18"
                size="30px"
                message={fijado === 0 ? 'Fijar' : fijado === 1 ? 'Desfijar' : "Click para abrir"}
                style={{ padding: "0px" }}
                isWhite
                onClick={(e) => {
                  e.preventDefault();
                  toggleFijado(fijado + 1);
                }}
            />
          </div>
          <div
            className="user user-menu-container "
            ref={userMenuRef}
            style={{marginTop:'80px'}}
            onMouseEnter={() => {
              if(sideBarRef.current){
                if(!sideBarRef.current.classList.contains('no-hover')){
                  setUserCollapseState(true)
                }
              }
            } 
          }
            onMouseLeave={() => {
              if(sideBarRef.current){
                if(!sideBarRef.current.classList.contains('no-hover')){
                  setUserCollapseState(false)
                }
              }
            } 
          }
          >
            <div
              className="d-flex photo align-items-center justify-content-center"
              style={{ marginLeft: "7px" }}
            >
              {usuario?.ImagenUsuarioERP ? (
                <img
                  alt="Imgen Usuario"
                  src={usuario.ImagenUsuarioERP}
                  style={{
                    maxWidth: "50px",
                    maxHeight: "50px",
                    minWidth: "50px",
                    minHeight: "50px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <SvgComponent
                  iconName="user"
                  height="40"
                  width="40"
                  fill={theme.color1}
                />
              )}
            </div>
            <div className="info-user" style={{ padding: "0px 0px " }}>
            <CustomToggle eventKey="0">
                <div
                  style={{
                    marginLeft: "80px",
                    cursor: "pointer",
                    paddingTop: "7px",
                    position: "sticky",
                    top: "10px",
                    height: "37px",
                    padding: "0px",
                    fontWeight: "700 !important",
                  }}
                  className={userCollapseState ? "collapsed" : "font-weight-bold"}
                  aria-expanded={userCollapseState}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="flex-column align-items-center user-info" style={{ marginTop: "8px" }}>
                      <h5 style={{ marginBottom: "0px" }}>
                        {usuario?.DescripcionUsuario.split(" ")[0]}
                      </h5>
                      <p style={{ marginBottom: "0px" }}>
                        <i>{usuario?.Compania?.Codigo.trim()}</i>
                      </p>
                    </div>
                  </div>
                </div>
              </CustomToggle>
              <div
                style={{
                  paddingTop: "15px",
                  borderTop: `${
                    userCollapseState ? "1px" : "0px"
                  } solid rgb(255 255 255 / 20%)`,
                  marginTop: userCollapseState ? "30px" : "0px",
                }}
              >
                <div className="user-menu-options p-0 mr-5">
                  <Nav
                    as="ol"
                    style={{
                      display: "block",
                    }}
                  >
                    <li>
                      <a
                        className="profile-dropdown"
                        onClick={(e) => {
                          e.preventDefault();
                          manageGoTo("/Seguridad/cambio_password.aspx")
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Col sm="1">
                            <span className="sidebar-mini">
                              <SvgComponent
                                iconName="cambiar contrasena"
                                height="24"
                                width="24"
                                fill="white"
                              />
                            </span>
                          </Col>
                          <Col md="8">
                            <span
                              style={{
                                wordBreak: "ellipsis",
                                fontWeight: "400",
                                fontSize: "1rem",
                              }}
                            >
                              Cambiar Contraseña
                            </span>
                          </Col>
                        </div>
                      </a>
                    </li>
                  </Nav>
                </div>
              </div>
            </div>
          </div>
          <Nav as="ul" style={{ marginBottom: "10px", display: "block" }}>
            {createLinks}
            {usuario?.Compania?.LicenciaActivaCRM ?? false ? (
              <Nav.Item className={"specialItem"} as="li" key={'crmLink'}>
                <Nav.Link
                  style={{
                    display: "flex",
                    alignContent: "left",
                    alignItems: "center",
                    textDecoration: "none",
                    outline: "none",
                    width: "-webkit-fill-available",
                    height: "45px",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    var url = configuration?.Vendor === 'claro'
                      ? "https://gestionnegociocrm.claro.com.do"
                      : "https://crm.citrus.com.do";
                    openInNewTab(url);
                  }}
                >
                  <div
                    style={{
                      marginLeft: "3px",
                      marginRight: "3px",
                      maxHeight: "35px",
                    }}
                  >
                    <SvgComponent
                      iconName="crm"
                      height="35"
                      width="35"
                      fill="white"
                    />
                  </div>
                  <p
                    style={{
                      marginLeft: "18px",
                      fontSize: "15px",
                      textAlign: "left",
                      backgroundColor: "unset",
                    }}
                    className="menuName"
                  >
                    CRM
                  </p>
                </Nav.Link>
              </Nav.Item>
            ) : null}
          </Nav>
        </div>
      )}
    </React.Fragment>
  );
};

